/*  global _, addiesaas */
/*eslint no-console: 0*/
import Vue from 'vue'

const EventBus = window.VueEventBus

import config from '../../lib/config'
import {parseNumber, getQS, coerceBoolean} from '../../lib/utils'
import {getNow, parseDateTime} from '../../lib/dates'

const {supercharged, TIMEZONE} = config

const qs = getQS() || {}

import PageMixins from '../../components/_mixins/pages'
import RaceMixins from '../../components/_mixins/races'
import CartMixins from '../../components/_mixins/location-checkout'
import ScrollMixins from '../../components/_mixins/scroller'
import PersonalDetailsMixins from '../../components/_mixins/personal-details'
import BookingMixin from '../../components/_mixins/booking'
import StepsMixins from './steps'
import VerbiageMixin from './verbiage'

const mixins = [
  RaceMixins,
  PageMixins,
  CartMixins,
  ScrollMixins,
  PersonalDetailsMixins,
  StepsMixins,
  BookingMixin,
  VerbiageMixin
]

import WouldYouLikeTo from '../../components/parts/would-you-like-to'

import AgreeToTerms from '../../components/parts/AgreeToTerms'
import TimeslotSelectorBox from './parts/timeslot-selector-box'
import MiniCart from './parts/mini-cart'

import {Datetime} from 'vue-datetime-extended'
import 'vue-datetime-extended/dist/vue-datetime-extended.css'

const racerDetailsItem = {
  racerName: 'Racer',
  type: 'adult',
  quantity: 1,
  membership: '',
  guest: false,
}

const components = {
  AgreeToTerms,
  Datetime,
  TimeslotSelectorBox,
  MiniCart,
  WouldYouLikeTo,
}

export default {
  name: 'page-book-cs-reservation',
  components,
  mixins,
  props: {
    settings: {},
    translations: {},
    reservationRaceType: {
      default: 'pro'
    },
    reservationTitle: {
      default: 'Pro Race'
    },
    reservationPageRoute: {
      default: 'racewaybooking.race'
    },
    usePointPackages: {
      default: false
    }
  },
  data() {
    return {
      isOneRaceType: true,
      timeZone: TIMEZONE,
      infoImageUri: config.TIMESLOT_INFO_IMAGE,
      formValidated: false,
      showBookGroupEventPrompt: false,
      showRemoveExistingPrompt: false,
      hasRacersChanged: false,
      racersChangedAlert: '',
      freezeSlotRetrieval: false,
      editMode: false,
      editingId: null,
      currentRacerDetails: [],//[_.clone(racerDetailsItem)],
      numRacers: null,
      numRacersReset: null,
      contactPhone: supercharged.phone_with_extension || '774-847-9010,101',
      isAddingToCart: false,
    }
  },
  computed: {
    pageClasses() {
      return [
        `page-${this.raceType}`
      ]
    },
    contactPhoneExt() {
      return this.contactPhone.replace(',', ' ext. ')
    },
    equalsMaxRacers() {
      return this.totalPlayers >= this.maxRacers
    },
    moreThanMaxRacers() {
      return this.totalPlayers > this.maxRacers
    },
    maxAccommodation() {
      return _.toFinite(this.raceSettingProduct.max_accommodation)
    },
    racersLimit() {
      return this.maxRacers
    },
    moreThanRacersLimit() {
      return this.totalPlayers > this.racersLimit
    },
    isGroupEventDetected() {
      return this.moreThanRacersLimit
    },
    raceSettings() {
      const type = this.raceType
      const {races = {}} = supercharged
      return races[type] || {}
    },
    productIds() {
      let products = this.raceSettings.products
      if (_.isString(products)) {
        products = JSON.parse(products)
      }
      return products || []
    },
    raceSettingProductId() {
      return _.toFinite(_.head(this.productIds))
    },
    raceSettingProduct() {
      return _.find(_.flatten(_.values(addiesaas.products.types)), p => p.id === this.raceSettingProductId) || {}
    },
    useTierPricing() {
      return !!_.toFinite(this.raceSettingProduct.use_tier_pricing)
    },
    minRacers() {
      return _.toFinite(this.raceSettingProduct.min_participants)
    },
    maxRacers() {
      return _.toFinite(this.raceSettingProduct.max_participants)
    },
    maxRacesPerRacer() {
      return _.toFinite(this.raceSettingProduct.max_races_per_participants)
    },
    anyRacerDetailsEmpty(){
      return _.some(this.currentRacerDetails, item => !item.type || !parseNumber(item.quantity))
    },
    racerDetailsLength() {
      return this.currentRacerDetails.length
    },
    timeoutDuration() {
      const timerTimeout = qs.timeout
      return _.toFinite(timerTimeout || this.raceSettingProduct.hold_timeout)
    },
    availabilityBuffer() {
      return _.toFinite(this.raceSettingProduct.availability_buffer) || 0 //minutes
    },
    racersLimitPerTimeslot() {
      return this.maxAccommodation || this.racersLimit
    },
    disableGroupEventMessage() {
      return coerceBoolean(this.raceSettingProduct.disable_group_event_message)
    },
    autoRaceSeparately() {
      return coerceBoolean(this.raceSettingProduct.auto_race_separately)
    },
    maxDate() {
      //hours_in_advance ?
      const daysInFuture = _.toFinite(this.raceSettingProduct.days_in_future)
      if (daysInFuture <= 0) {
        return null
      }
      const now = getNow(TIMEZONE).startOf('day')
      const endDate = now.plus({ days: daysInFuture})
      return endDate.toISODate()
    },
    minDate() {
      const noMinDate = qs.noMinDate
      if (noMinDate) {
        return null
      }
      const now = getNow(TIMEZONE).startOf('day')
      return now.toISODate()
    },
    disableWeekDays() {
      return this.$$s('disableWeekDays', null)
    },
    disableDates() {
      return this.$$s('disableDates', null)
    },
  },
  watch: {
    raceSettingProduct: {
      handler(product) {
        this.setSetting({selectedProduct: product})
      },
      immediate: true
    },
    showMiniCart(newValue, oldvalue) {
      if (this.preventTimerStartInEditMode) {
        return
      }
      if (newValue) {
        if (!this.timerIsRunning) {
          const holdStartsAt = this.holdStartsAt = getNow().toSeconds()
          this.holdEndsAt = (1 * holdStartsAt) + this.timeoutDuration
          this.startTimer(this.timeoutDuration)
        }
        if (!this.holdStartsAt || !this.holdEndsAt) {
          this.holdStartsAt = parseDateTime(this.timerStartTime).toSeconds()
          this.holdEndsAt = parseDateTime(this.timerEndTime).toSeconds()
        }
      } else {
        if (!this.needsToShowTimer) {
          this.stopTimer()
        }
      }
    },
    async selectedDate(newValue, oldValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue && !this.freezeSlotRetrieval) {
        newValue = ('' + newValue).trim()
        const timeslots = await this.retrieveTimeslots(newValue)
        this.updateRacersRacesMatrixOnSelection()
      }
      this.freezeSlotRetrieval = false
    },
    totalPlayers(newValue, oldValue) {
      const slotted = this.totalRacersSlottedGrouped || 0
      this.hasRacersChanged = false
      this.racersChangedAlert = ''

      if (this.isGroupEventDetected) {
        newValue = 0
      }
    },
    numRacers(val, oldVal) {
      if (!this.numRacersReset) {
        this.watchNumRacers()
      }
      this.numRacersReset = null
    },
    numberOfAdults(val, oldVal) {
      if (this.isHydratingData) {
        this.numRacers = val
      }
      this.watchNumRacers()
      this.modifyRacerDetails(val, oldVal)
      if (val < oldVal) {
        this.cleanTimeslots()
      }
    },
  },
  async created() {
    this.hideGlobalTimer(true)
    this.mayResetCountdownTimer()

    this.setRaceTypes([this.reservationRaceType || 'pro'])
    this.raceType = this.reservationRaceType || 'pro'
    this.raceTitle = this.reservationTitle
    this.editRoute = this.reservationPageRoute

    this.usePackages = this.usePointPackages
    this.hasGroupedSlots = true
    this.buffer = this.availabilityBuffer

    EventBus.$on('cart-item-edit-reservations', async (item, cartItem, cart) => {
      await this.hydrateRacesFromCart(item, cartItem, cart)
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-item-added-reservations', (item, cartItem, cart) => {

    })
    EventBus.$on('cart-item-deleted-reservations', (item, cartItem, cart) => {
      this.cleanTimeslots()
      this.unsetLocalCartItem(item)
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-cleaned', cart => {
      this.cleanTimeslots()
      this.clearLocalCart()
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-go-back', cart => {
      // this.goBackToRaceShop()
    })
    EventBus.$on('cart-get-item-description', (item, cartItem, cart) => {
      // .selected-time-slots
    })
    EventBus.$on('timer.timeout', id => {
      if (id === this.currentLocationId) {
        const canAutoRemove = this.autoRemoveCartItemOnTimeout
        if (canAutoRemove) {
          this.cleanExistingItems()
        } else {
          this.cleanSelectedTimeslots()
        }
        let message = 'Time to hold your selection for reservation has expired.'
        if (this.editMode && canAutoRemove) {
          message += ' Your cart item has been removed.'
        }
        message += ' Please start over again!'
        this.$nextTick(() => {
          this.scrollTo('.racers-date-input-box')
        })
        this.alert(message, {classes: 'text-danger'})
      }
    })

    await this.setEditItem(qs.item || this.$route.query.item)
    if (this.editMode) {
      this.editingId = this.raceEditItem.id
      const expired = this.hasExpired(this.raceEditItem)
      if (expired) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
        this.mayResetCountdownTimer()
      }
      if (!expired || !this.autoRemoveCartItemOnEditTimeout) {
        EventBus.$emit('cart-item-edit-reservations', this.raceEditItem)
      }
    }

    this.updateRacersBreakup()
  },
  methods: {
    async setEditItem(id) {
      // this.editMode = !!this.raceEditItem && _.get(this.raceEditItem, 'attributes.form.raceType') === this.raceType
      id = id || qs.item || this.$route.query.item
      if (id) {
        id = decodeURIComponent(id)
        const item = this.cartItems[id]
        if (item && item.type === 'race-reservations' && _.get(item, 'attributes.form.raceType') === this.raceType) {
          await this.setRaceEditItem(item)
          this.editMode = true
        }
      }
    },
    watchNumRacers:  _.debounce(function(event) {
      const newValue = Math.max(0, Math.round(this.numRacers) || 0)
      if (newValue && this.minRacers && newValue < this.minRacers) {
        this.alert('Number of participants can not be less than ' + this.minRacers)
        return
      }
      this.numRacers = this.numRacers === '' ? '' : newValue
      this.askAndRemoveSelectedTimeSlot(
        'change in the number of participants',
        () => {
          if (this.numberOfAdults !== newValue) {
            this.numberOfAdults = newValue
            this.$nextTick(() => {
              this.showPrompts()
            })
          }

        },
        () => {
          if (this.numberOfAdults !== this.numRacers) {
            this.numRacersReset = true
            this.numRacers = this.numberOfAdults
          }
        },
        () => {

        }
      );
    }, 500),
    watchChosenDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue) {
        newValue = ('' + newValue).trim()
        this.askAndRemoveSelectedTimeSlot('change in date',
          () => {
            this.selectedDate = newValue
          },
          () => {
            this.chosenDate = this.selectedDate
          },
        )
      }
    },
    hasExpired(item) {
      let expired = this.hasTimerExpired(item)
      if (!expired) {
        const earliestSlotTime = this.getEarliestSlotTime(item)
        if (earliestSlotTime) {
          expired = getNow(this.timezone, true) >= (earliestSlotTime - (this.availabilityBuffer * 60))
        }
      }
      return expired
    },
    hasTimerExpired(item) {
      const ends = 1 * _.get(item, 'payload.options.form.holdEndsAt', 0)
      // console.log(item, ends)
      if (ends) {
        return getNow().toSeconds() >= ends
      }
      return false

    },
    navigateToBookEvents() {
      window.location.assign(config.GROUP_EVENTS_URL)
    },
    addToLocalCart(data) {
      const prevCartId = this.input('cartId')
      if (prevCartId) {
        this.unsetLocalCartItem({date: prevCartId})
      }

      const date = parseDateTime(this.selectedDate).toISODate()
      this.setInput({cartId: date})
      const slots = _.clone(this.retrievedTimeslots, true)
      const inputs = _.clone(this.input(), true)
      this.setLocalCartItem({date, slots, inputs})
    },
    cleanSelectedTimeslots() {
      this.cleanTimeslots()
    },
    cleanExistingItems() {
      this.cleanSelectedTimeslots()
      this.clearLocalCart()
      if (this.editMode) {
        this.removeExitingCartItems(this.editingId)
        this.editMode = false
      }
    },
    async removeExitingCartItems(id) {
      const mainItem = this.cartItem(id)
      this.editingId = null
      if (mainItem) {
        const slots = _.values(_.get(mainItem, 'attributes.form.selectedSlots', {}))
        const children = _.values(_.cloneDeep(_.get(mainItem, 'attributes.childItems', {})))
        if (this.usePackages) {
          for(let id of children) {
            await this.removeCartItem({id})
          }
        } else {
          for(let slot of slots) {
            await this.removeCartItem(slot)
          }
        }
        await this.removeCartItem({id: mainItem.id})
      }
    },
    hasExistingCartItem() {
      const cart = _.filter(this.currentCartItems || {}, ({type}) => type === this.reservationType)
      if (!this.editingId && !_.isEmpty(cart)) {
        const cartIds = _.reduce(cart, (items, {id}) => ({[id]: true, ...items}), {})
        const proposed = _.filter(this.proposedCart, ({type}) => type === this.reservationType)
        const proposedIds = _.reduce(proposed, (items, {id}) => [id, ...items], [])
        return _.some(proposedIds, id => cartIds[id] || false)
      }
      return false
    },
    async addToCart(goto = true) {
      await this.finallyAddToCart(goto)
    },
    async finallyAddToCart(goto) {
      this.isAddingToCart = true
      const cartPage = 'page-cart'
      this.addToLocalCart()

      if (this.editingId || this.hasExistingCartItem()) {
        await this.removeExitingCartItems(this.editingId)
      }

      await this.$nextTick()
      await this.addCartItems(this.proposedCart)
      this.setRaceEditItem(null)
      if (goto) {
        await this.$nextTick()
        this.goto(cartPage)
      } else {
        this.isAddingToCart = false
      }
    },
    showPrompts: _.debounce(function () {
      this.showBookGroupEventPrompt = this.moreThanRacersLimit
    }, 500),
    modifyRacerDetails:  _.debounce(function (val, oldVal) {
      if (val >= 1 && val <= this.maxRacers) {
        const details = this.currentRacerDetails
        const length = details.length
        const change = val - length
        if (change > 0) {
          for (let index = 0; index < change; index++) {
            this.addRacerDetails(true)
          }
        } else if (change < 0) {
          this.askAndRemoveSelectedTimeSlot('change in the number of racers', () => {
            const deleteStartIndex = length + change
            this.currentRacerDetails.splice(deleteStartIndex, Math.abs(change))
            for (let index = length - 1; index >= deleteStartIndex; index--) {
              this.deleteRacerDetails(index)
            }
            this.$nextTick(() => {
              this.updateRacersBreakup()
            })
          })
        }
      }
    }, 500),
    addRacerDetails(force) {
      if (!force && this.equalsMaxRacers) {
        this.showBookGroupEventPrompt = true
      } else {
        this.askAndRemoveSelectedTimeSlot('change in the number of racers', () => {
          const racerDetails = _.clone(racerDetailsItem)
          this.currentRacerDetails.push(racerDetails)
          const racer = _.last(this.currentRacerDetails)
          const index = this.currentRacerDetails.length - 1
          this.syncRacerDetails({racer, index})
        })
      }
    },
    decreaseRacesForRacer({racer, index}) {
      if (this.totalRacesNotSlotted <= 0) {
        this.askAndRemoveSelectedTimeSlot('decrease in the number of races', () => {
          this.finallyDecreaseRacesForRacer({racer, index})
        })
      } else {
        this.finallyDecreaseRacesForRacer({racer, index})
      }
    },
    finallyDecreaseRacesForRacer({racer, index}) {
      racer.quantity = Math.max(racer.quantity - 1, 1)
      this.syncRacerDetails({racer, index})
      this.showPrompts(racer, index)
    },
    increaseRacesForRacer({racer, index}) {
      racer.quantity = Math.min(racer.quantity + 1, this.maxRacers)
      this.syncRacerDetails({racer, index})
      this.showPrompts(racer, index)
    },
    syncRacerDetails(data) {
      this.$nextTick(() => {
        this.updateRacerDetails(_.cloneDeep(data))
        this.updateRacersBreakup()
      })
    },
    removeRacerDetails(index) {
      this.askAndRemoveSelectedTimeSlot('change in the number of racers', () => {
        this.finallyRemoveRacerDetails(index)
      })
    },
    finallyRemoveRacerDetails(index) {
      this.currentRacerDetails.splice(index, 1)
      this.$nextTick(() => {
        this.deleteRacerDetails(index)
        this.updateRacersBreakup()
      })
    },
    updateRacersBreakup() {
      const all = this.currentRacerDetails || []
      // this.numberOfAdults =  _.reduce(all, (s, {quantity}) => s + ((!!quantity) * 1), 0)
      this.numberOfAdultRaces = _.reduce(all, (s, {quantity}) => s + parseNumber(quantity), 0)
      this.racerRacesMatrix = this.getRacerRacesMatrix(all)
      this.updateRacersRacesMatrixOnSelection()
    },
    getRacerRacesMatrix(racers) {
      // fill each racer with array (of value 1 in each cell) having size of number of races
      let races =  _.reduce(racers, (s, {quantity}) => [...s,  _.fill(Array(quantity), 1, 0, quantity)], [])
      // transpose to get min heats/timeslots required (length of root array)
      races = _.zip(...races)
      // store count of 1 in each sub array as max allowed races per timeslot
      // sort descending
      races = _.map(races, r => (r.filter(i => i)).length).sort((a, b) => b - a)
      // console.log(races)
      races = _.map(races, r => ({max: r, filled: false}))

      return races
    },
    checkRacerLimits(racer, index) {
      if (racer.quantity) {
        const max = /titanium/.test(racer.membership) ? this.maxTitaniumRacesPerRacer : this.maxRacesPerRacer
        if (racer.quantity > max) {
          if (/titanium/.test(racer.membership)) {
            racer.quantity = this.maxTitaniumRacesPerRacer
            this.showMaxTitaniumRacesPrompt = true
          } else {
            racer.quantity = this.maxRacesPerRacer
            this.showMaxRacesPrompt = true
          }
          this.syncRacerDetails({index, racer})
          return false
        }
        return true
      }
    },

    async hydrateRacesFromCart(cartItem, cartItemComponent, cartComponent) {
      this.startHydratingData(true)
      const hasExpired = this.hasExpired(cartItem)
      this.freezeSlotRetrieval = true
      const {attributes, cartId} = cartItem
      const {form: inputs} = attributes
      const selectedSlots = hasExpired ? {} : _.clone(inputs.selectedSlots)
      const otherInputs = _.clone(_.omit(inputs, ['selectedSlots', 'racerDetails']))
      this.setInput(otherInputs)
      const racerDetails = _.cloneDeep(inputs.racerDetails)
      this.currentRacerDetails = _.cloneDeep(racerDetails)
      this.setInput({racerDetails})
      this.phoneConfirmation = _.get(otherInputs, 'contact.phone')
      this.emailConfirmation = _.get(otherInputs, 'contact.email')
      this.chosenDate = this.selectedDate
      const timeslots = await this.retrieveTimeslots(inputs.selectedDate)

      this.selectedSlots = hasExpired ? {} : inputs.selectedSlots

      await this.$nextTick()
      // this.setInput({selectedSlots})
      _.forOwn(selectedSlots, slot => {
        // // const setTimeslot = this.retrievedTimeslot(slot.time)
        const {time, selected, racers, hold, children, parent} = slot
        const data = [
          {time, key: 'selected', value: true},
          {time, key: 'racers', value: racers},
          {time, key: 'hold', value: hold},
          {time, key: 'children', value: children},
          {time, key: 'parent', value: parent},
        ]
        this.setRetrievedTimeslotDataItems(data)
        const updates = {time, selected, racers, hold, children, parent}
        this.setTimeslot(updates)
      })

      this.updateRacersBreakup()
      this.$forceUpdate()

      await this.$nextTick()
      if (hasExpired) {
        this.cleanSelectedTimeslots()
      }

      await this.$nextTick()
      // this.setRaceEditItem(null)
      this.startHydratingData(false)
      this.updateRacersRacesMatrixOnSelection()
      this.preventTimerResetInEditMode = false
    },

    async likeClick() {
      if (!this.cartNotReady) {
        await this.addToCart(false)
      }
    },
  }

}
